import { graphql, HttpResponse } from 'msw'
import { type EnrollmentJointDeclineSubmitOutput } from '../../../../models/enrollment/joint/decline'

export const submitEnrollmentJointDeclineDataMock: EnrollmentJointDeclineSubmitOutput = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/decline',
  },
}

export const mockSubmitEnrollmentJointDeclineData = graphql.mutation('submitEnrollmentJointDeclineData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointDeclineDataMock } })
})

export const mockEnrollmentJointDecline = [mockSubmitEnrollmentJointDeclineData]
